export default __webpack_public_path__ + "static/media/Terms.60db4c12.png";